import { createSelector } from '@ngrx/store';
import { alertingFeature } from './alerting.reducer';

export const selectTopics = createSelector(alertingFeature.selectTopics, (topics) => Object.values(topics ?? {}));
export const selectNotifications = createSelector(alertingFeature.selectNotifications, (notifications) =>
  Object.values(notifications ?? {}),
);

export const selectPriceAlertCount = createSelector(alertingFeature.selectPriceAlertOverview, (priceAlertOverview) =>
  priceAlertOverview.map((priceAlert) => priceAlert.alerts.filter((alert) => !!alert.active).length).reduce((a, b) => a + b, 0),
);
export const selectMaxPriceAlertsReached = createSelector(alertingFeature.selectStatus, (status) => status === 'MAX_ITEMS_REACHED');

export const selectUpdating = createSelector(alertingFeature.selectStatus, (status) => status === 'UPDATING');
export const selectDeleted = createSelector(alertingFeature.selectStatus, (status) => status === 'DELETE_SUCCESS');

export const selectHasAlertByIsin = (isin: string) =>
  createSelector(alertingFeature.selectPriceAlertOverview, (priceAlertOverview) =>
    priceAlertOverview.some((priceAlert) => priceAlert.isin === isin),
  );
